import React from 'react'
import { useDarkMode } from '../../../context/DarkModeContext'

function Toast({ message, error, onClose }) {
	const { isDarkMode } = useDarkMode()
	
	const baseStyle = {
		position: 'fixed',
		top: '20px',
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: 9999,
		padding: '12px 16px',
		borderRadius: '8px',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
		textAlign: 'center',
		fontWeight: '500',
		maxWidth: '400px',
		minWidth: '250px',
		animation: 'slideDown 0.3s ease-out'
	}
	
	const errorStyle = isDarkMode 
		? { backgroundColor: '#7f1d1d', color: '#fecaca', border: '1px solid #991b1b' }
		: { backgroundColor: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }
		
	const successStyle = isDarkMode 
		? { backgroundColor: '#14532d', color: '#bbf7d0', border: '1px solid #166534' }
		: { backgroundColor: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0' }
	
	return (
		<>
			<style>{`
				@keyframes slideDown {
					from { 
						transform: translateX(-50%) translateY(-20px);
						opacity: 0;
					}
					to { 
						transform: translateX(-50%) translateY(0);
						opacity: 1;
					}
				}
			`}</style>
			<div style={{...baseStyle, ...(error ? errorStyle : successStyle)}}>
				<span style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
					{message}
					{onClose && (
						<button
							type="button"
							onClick={onClose}
							aria-label="Close notification"
							style={{
								background: 'none',
								border: 'none',
								padding: 0,
								cursor: 'pointer',
								color: 'inherit',
								fontSize: '16px',
								lineHeight: 1,
								opacity: 0.7,
							}}
						>
							×
						</button>
					)}
				</span>
			</div>
		</>
	)
}

export default Toast
